import { Component } from "@angular/core";

@Component({
    selector: "deloitteai-contact-banner",
    templateUrl: "./contact-banner.component.html",
    styleUrls: ["./contact-banner.component.scss"],
})
export class DeloitteAiContactBannerComponent { }
